import { initial, last } from "lodash";

export function prettyFormatList(list: string[]) {
  if (!initial(list).length) {
    return last(list);
  }

  return `${initial(list).join(", ")} or ${last(list)}`;
}
